import { render, staticRenderFns } from "./PhoneCapability.vue?vue&type=template&id=98c23d6c&scoped=true&"
import script from "./PhoneCapability.vue?vue&type=script&lang=js&"
export * from "./PhoneCapability.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCapability.vue?vue&type=style&index=0&id=98c23d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c23d6c",
  null
  
)

export default component.exports